import { j as v } from "./jsx-runtime-3tyXYecC.mjs";
import { l as y } from "./lodash-5ofSKtz3.mjs";
import { forwardRef as ee, useRef as ae, useImperativeHandle as se, useMemo as te } from "react";
import { f as ie } from "./index-LyFokDcn.mjs";
import { O as oe } from "./outlined-input-wBBzs904.mjs";
import { I as re } from "./input-wrapper-qaVcukod.mjs";
import { u as le } from "./use-readable-context-BO-ExsvT.mjs";
import { w as ne } from "./sizes-DktS74Qp.mjs";
import { m as ce } from "./tss-DN0acMKN.mjs";
import { _ as de } from "./composeRefs-YONvD-rx.mjs";
import { g as me } from "./get-aria-describedby-G1wcWKF2.mjs";
import { g as ue } from "./get-status-message-CGqgCpjJ.mjs";
const fe = ce()((t, o) => {
  const { labelPlacement: r, size: s, width: a } = o, l = s ? {
    teenie: "32px",
    small: "32px",
    medium: "40px",
    large: "48px",
    biggie: "48px"
  }[s] : void 0;
  return {
    label: {
      height: r === "inline" ? l : void 0
    },
    width: {
      width: !a || a === 100 ? "100%" : ne[a]
    }
  };
}), Se = ee((t, o) => {
  const { isReadable: r } = le();
  let s = t;
  const { viewMode: a = r } = t;
  if (a) {
    const { placeholder: c, ...$ } = t;
    s = $;
  }
  const {
    apiRef: d,
    ariaDescribedby: l,
    InputLabelProps: F,
    InputProps: e,
    afterLabel: M,
    autoFocus: j,
    biId: S,
    classes: m = {},
    className: z,
    containerRef: C,
    defaultValue: I,
    disabled: u = !1,
    errorMessage: T,
    focusRing: q = !0,
    inputProps: D,
    label: k,
    labelPlacement: f = "block",
    maxRows: B,
    minRows: E,
    multiline: H = !1,
    name: L,
    note: O,
    notePlacement: V = "inline",
    onBlur: _,
    onChange: A,
    onFocus: K,
    onKeyDown: N,
    placeholder: P,
    required: W = !1,
    rows: G,
    rowsMax: J,
    size: b = "medium",
    status: i,
    warningMessage: Q,
    value: U,
    variant: p,
    width: x = 100,
    ...X
  } = s, { classes: g } = fe({ labelPlacement: f, size: b, width: x }), h = s.id || y.uniqueId("FabricTextField-"), Y = [X["data-fabric-component"], "TextField"].filter(Boolean).join(" "), Z = ie.ifFeature(
    "encore",
    {
      label: g.label,
      ...m ?? {}
    },
    m
  ), n = ae();
  se(
    d,
    () => ({
      focus: () => {
        var c;
        (c = n.current) == null || c.focus();
      }
    }),
    [n]
  );
  const w = te(() => y.uniqueId("fabric-text-field-status-message-"), []), R = ue(i, T, Q);
  return /* @__PURE__ */ v.jsx(
    re,
    {
      afterLabel: M,
      classes: Z,
      className: z,
      "data-fabric-component": Y,
      disabled: u,
      id: h,
      InputLabelProps: F,
      label: k,
      labelPlacement: f,
      note: O,
      notePlacement: V,
      ref: C,
      required: W,
      status: i,
      statusMessage: R,
      statusMessageId: w,
      variant: p,
      viewMode: a,
      width: x,
      children: /* @__PURE__ */ v.jsx(
        oe,
        {
          ...e,
          "aria-describedby": me(
            R ? w : "",
            l,
            e == null ? void 0 : e["aria-describedby"]
          ),
          "aria-invalid": i === "error" || (e == null ? void 0 : e["aria-invalid"]),
          autoFocus: j,
          biId: S,
          classes: {
            root: g.width,
            // TODO: This needs to be addressed at some point. Right now the InputProps.classes are
            // overriding the root classes and causing certain TextField classes to not get applied
            // when they probably should.
            // The issue is documented more in depth here:
            // https://bamboohr.slite.com/app/docs/FxXrhP0bQkW2fE#c264357a
            ...(e == null ? void 0 : e.classes) || {}
          },
          defaultValue: I,
          disabled: u,
          focusRing: q,
          id: h,
          inputProps: D,
          maxRows: B ?? J,
          minRows: E,
          multiline: H,
          name: L,
          onBlur: _,
          onChange: A,
          onFocus: K,
          onKeyDown: N,
          placeholder: P,
          ref: de(o, n),
          rows: G,
          size: b,
          status: i,
          value: U,
          variant: p,
          viewMode: a
        }
      )
    }
  );
});
export {
  Se as T
};
//# sourceMappingURL=text-field-ZOMRKQAY.mjs.map
